module.exports = __webpack_public_path__ + "img/macedonians-barbarian.86993657.png";